"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastIcon = exports.Toast = exports.TextContainer = exports.NotificationText = exports.NotificationItem = exports.MDSCloseIcon = exports.DefaultIcon = exports.ButtonMenuContainer = exports.Button = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Button = require("../../Button");
var _Warning = _interopRequireDefault(require("../../Icons/Status/Warning"));
var _NavigationClose = _interopRequireDefault(require("../../Icons/NavigationClose"));
var _constants = require("../constants");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const getFillColor = ({
  theme,
  category,
  fill
}) => {
  if (theme.name === 'mds' && category === 'warn') {
    return theme.colors.toast.warnText;
  }
  return fill;
};
const DefaultIcon = exports.DefaultIcon = (0, _styledComponents.default)(_Warning.default).attrs(prop => ({
  fill: getFillColor(prop)
})).withConfig({
  displayName: "styles__DefaultIcon",
  componentId: "sc-yyuno6-0"
})([""]);
const fade = (0, _styledComponents.keyframes)(["from{opacity:0;height:0;}to{opacity:1;height:", ";}"], ({
  theme
}) => theme.toast.btnContainerHeight);
const Button = exports.Button = (0, _styledComponents.default)(_Button.Button).withConfig({
  displayName: "styles__Button",
  componentId: "sc-yyuno6-1"
})(["animation:", " 0.2s ease-out;border:", ";margin:", ";&:hover{border:", ";}&:active{border:", ";}", " ", ""], fade, ({
  theme
}) => theme.toast.buttonBorder, ({
  theme
}) => theme.toast.btnActionMargin, ({
  theme
}) => theme.toast.buttonBorderHover, ({
  theme
}) => theme.toast.buttonBorderActive, ({
  theme,
  category,
  variant
}) => (0, _styledComponents.css)(["", " ", " ", " ", " ", " ", ""], category === _constants.TOAST_CATEGORIES.INFO && (0, _styledComponents.css)(["background-color:", ";color:", ";&:hover{background-color:", ";}&:active{background-color:", ";}", ""], theme.colors.toast.actionsInfoBg, theme.colors.toast.infoButtonText, theme.colors.toast.actionsInfoBgHover ?? 'inherit', theme.colors.toast.actionsInfoBgActive ?? 'inherit', theme.name === 'mds' && variant === 'primary' && (0, _styledComponents.css)(["color:", ";background-color:", ";&:hover{background-color:", ";}&:active{background-color:", ";}"], theme.colors.toast.primaryBtn.infoText, theme.colors.toast.primaryBtn.infoBg, theme.colors.toast.primaryBtn.infoBgHover, theme.colors.toast.primaryBtn.infoBgActive)), category === _constants.TOAST_CATEGORIES.DANGER && (0, _styledComponents.css)(["background-color:", ";color:", ";&:hover{background-color:", ";}&:active{background-color:", ";}", ""], theme.colors.toast.actionsDangerBg, theme.colors.toast.dangerButtonText, theme.colors.toast.actionsDangerBgHover ?? 'inherit', theme.colors.toast.actionsDangerBgActive ?? 'inherit', theme.name === 'mds' && variant === 'primary' && (0, _styledComponents.css)(["color:", ";background-color:", ";&:hover{background-color:", ";}&:active{background-color:", ";}"], theme.colors.toast.primaryBtn.dangerText, theme.colors.toast.primaryBtn.dangerBg, theme.colors.toast.primaryBtn.dangerBgHover, theme.colors.toast.primaryBtn.dangerBgActive)), category === _constants.TOAST_CATEGORIES.SUCCESS && (0, _styledComponents.css)(["background-color:", ";color:", ";&:hover{background-color:", ";}&:active{background-color:", ";}", ""], theme.colors.toast.actionsSuccessBg, theme.colors.toast.successButtonText, theme.colors.toast.actionsSuccessBgHover ?? 'inherit', theme.colors.toast.actionsSuccessBgActive ?? 'inherit', theme.name === 'mds' && variant === 'primary' && (0, _styledComponents.css)(["color:", ";background-color:", ";&:hover{background-color:", ";}&:active{background-color:", ";}"], theme.colors.toast.primaryBtn.successText, theme.colors.toast.primaryBtn.successBg, theme.colors.toast.primaryBtn.successBgHover, theme.colors.toast.primaryBtn.successBgActive)), category === _constants.TOAST_CATEGORIES.ERROR && (0, _styledComponents.css)(["background-color:", ";color:", ";&:hover,&:active{background-color:", ";}", ""], theme.colors.toast.actionsErrorBg, theme.colors.toast.errorButtonText, theme.colors.toast.actionsErrorBg ?? 'inherit', theme.name === 'mds' && variant === 'primary' && (0, _styledComponents.css)(["color:", ";background-color:", ";&:hover,&:active{background-color:", ";}"], theme.colors.toast.primaryBtn.errorText, theme.colors.toast.primaryBtn.errorBg, theme.colors.toast.primaryBtn.errorBg)), category === _constants.TOAST_CATEGORIES.WARN && (0, _styledComponents.css)(["background-color:", ";color:", ";&:hover{background-color:", ";}&:active{background-color:", ";}", " ", ""], theme.colors.toast.actionsWarnBg, theme.colors.toast.warnButtonText, theme.colors.toast.actionsWarnBgHover ?? 'inherit', theme.colors.toast.actionsWarnBgActive ?? 'inherit', theme.name === 'mds' && (0, _styledComponents.css)(["color:", ";border:", ";&:hover,&:active{border:", ";}"], theme.colors.toast.warnText, theme.toast.warnBorder, theme.toast.warnBorder), theme.name === 'mds' && variant === 'primary' && (0, _styledComponents.css)(["color:", ";background-color:", ";&:hover{background-color:", ";}&:active{background-color:", ";}"], theme.colors.toast.primaryBtn.warnText, theme.colors.toast.primaryBtn.warnBg, theme.colors.toast.primaryBtn.warnBgHover, theme.colors.toast.primaryBtn.warnBgActive)), category === _constants.TOAST_CATEGORIES.NEUTRAL && (0, _styledComponents.css)(["background-color:", ";color:", ";&:hover{background-color:", ";}&:active{background-color:", ";}", ""], theme.colors.toast.actionsNeutralBg, theme.colors.toast.neutralButtonText, theme.colors.toast.actionsNeutralBgHover ?? 'inherit', theme.colors.toast.actionsNeutralBgActive ?? 'inherit', theme.name === 'mds' && variant === 'primary' && (0, _styledComponents.css)(["color:", ";background-color:", ";&:hover{background-color:", ";}&:active{background-color:", ";}"], theme.colors.toast.primaryBtn.neutralText, theme.colors.toast.primaryBtn.neutralBg, theme.colors.toast.primaryBtn.neutralBgHover, theme.colors.toast.primaryBtn.neutralBgActive))), ({
  theme
}) => theme.name !== 'mds' && (0, _styledComponents.css)(["opacity:0.9;"]));
const ButtonMenuContainer = exports.ButtonMenuContainer = _styledComponents.default.div.withConfig({
  displayName: "styles__ButtonMenuContainer",
  componentId: "sc-yyuno6-2"
})(["display:flex;align-items:center;height:", ";padding:0;"], ({
  theme
}) => theme.toast.btnContainerHeight);
const Toast = exports.Toast = _styledComponents.default.div.withConfig({
  displayName: "styles__Toast",
  componentId: "sc-yyuno6-3"
})(["width:100%;position:relative;", ""], ({
  theme
}) => theme.name !== 'mds' && (0, _styledComponents.css)(["height:", ";"], theme.toast.toastContainerHeight));
const NotificationItem = exports.NotificationItem = _styledComponents.default.div.withConfig({
  displayName: "styles__NotificationItem",
  componentId: "sc-yyuno6-4"
})(["animation:", " 0.2s ease-out;display:flex;flex-direction:row;justify-content:space-between;align-items:center;height:100%;color:", ";position:absolute;left:0;right:0;bottom:0;top:0;", " ", "{margin:", ";}", "{&:last-child{margin:0;}}", " ", " ", " ", " ", " ", ""], fade, ({
  theme
}) => theme.colors.toast.text, ({
  theme
}) => theme.name === 'mds' && (0, _styledComponents.css)(["position:static;padding:12px 0;"]), ButtonMenuContainer, ({
  theme
}) => theme.toast.btnContainerMargin, Button, ({
  category,
  theme
}) => (category === _constants.TOAST_CATEGORIES.ERROR || category === 'high') && (0, _styledComponents.css)(["background:", ";color:", ";", "{background:", ";}"], theme.colors.toast.errorBg, theme.colors.toast.errorText, ButtonMenuContainer, theme.colors.toast.errorBg), ({
  category,
  theme
}) => category === _constants.TOAST_CATEGORIES.DANGER && (0, _styledComponents.css)(["background:", ";color:", ";", "{background:", ";}"], theme.colors.toast.dangerBg, theme.colors.toast.dangerText, ButtonMenuContainer, theme.colors.toast.dangerBg), ({
  category,
  theme
}) => category === _constants.TOAST_CATEGORIES.WARN && (0, _styledComponents.css)(["background:", ";color:", ";", "{background:", ";}"], theme.colors.toast.warnBg, theme.colors.toast.warnText, ButtonMenuContainer, theme.colors.toast.warnBg), ({
  category,
  theme
}) => (category === _constants.TOAST_CATEGORIES.INFO || category === 'normal') && (0, _styledComponents.css)(["background:", ";color:", ";", "{background:", ";}"], theme.colors.toast.infoBg, theme.colors.toast.infoText, ButtonMenuContainer, theme.colors.toast.infoBg), ({
  category,
  theme
}) => category === _constants.TOAST_CATEGORIES.SUCCESS && (0, _styledComponents.css)(["background:", ";color:", ";", "{background:", ";}"], theme.colors.toast.successBg, theme.colors.toast.successText, ButtonMenuContainer, theme.colors.toast.successBg), ({
  category,
  theme
}) => category === _constants.TOAST_CATEGORIES.NEUTRAL && (0, _styledComponents.css)(["background:", ";color:", ";", "{background:", ";}"], theme.colors.toast.neutralBg, theme.colors.toast.neutralText, ButtonMenuContainer, theme.colors.toast.neutralBg));
const TextContainer = exports.TextContainer = _styledComponents.default.div.withConfig({
  displayName: "styles__TextContainer",
  componentId: "sc-yyuno6-5"
})(["display:flex;align-items:center;height:100%;padding:0;flex:1;", ""], ({
  theme
}) => theme.name === 'mds' && (0, _styledComponents.css)(["margin-right:24px;"]));
const NotificationText = exports.NotificationText = _styledComponents.default.span.withConfig({
  displayName: "styles__NotificationText",
  componentId: "sc-yyuno6-6"
})(["font-size:", ";font-weight:", ";font-family:", ";line-height:", ";letter-spacing:", ";"], ({
  theme
}) => theme.toast.fontSize, ({
  theme
}) => theme.toast.fontWeight, ({
  theme
}) => theme.toast.fontFamily, ({
  theme
}) => theme.toast.lineHeight, ({
  theme
}) => theme.toast.letterSpacing);
const ToastIcon = exports.ToastIcon = (0, _styledComponents.default)(({
  component,
  ...props
}) => _react.default.cloneElement(component, props)).withConfig({
  displayName: "styles__ToastIcon",
  componentId: "sc-yyuno6-7"
})(["height:", ";width:", ";margin:", ";flex-shrink:0;", ""], ({
  theme
}) => theme.toast.iconHeight, ({
  theme
}) => theme.toast.iconWidth, ({
  theme
}) => theme.toast.iconMargin, ({
  category,
  theme
}) => {
  if (category === 'info' || category === 'normal') {
    return (0, _styledComponents.css)(["fill:", ";"], theme.colors.toast.infoIcon);
  }
  if (category === 'warn') {
    return (0, _styledComponents.css)(["fill:", ";"], theme.colors.toast.warnIcon);
  }
  if (category === 'error' || category === 'high') {
    return (0, _styledComponents.css)(["fill:", ";"], theme.colors.toast.errorIcon);
  }
});
const MDSCloseIcon = exports.MDSCloseIcon = (0, _styledComponents.default)(_NavigationClose.default).withConfig({
  displayName: "styles__MDSCloseIcon",
  componentId: "sc-yyuno6-8"
})(["cursor:pointer;margin-left:16px;flex-shrink:0;", ""], ({
  category,
  theme
}) => {
  if (category === _constants.TOAST_CATEGORIES.INFO || category === 'normal') {
    return (0, _styledComponents.css)(["fill:", ";&:hover{fill:", ";}"], theme.colors.toast.infoIcon, theme.colors.toast.infoIconHover);
  }
  if (category === _constants.TOAST_CATEGORIES.WARN) {
    return (0, _styledComponents.css)(["fill:", ";&:hover{fill:", ";}"], theme.colors.toast.warnIcon, theme.colors.toast.warnIconHover);
  }
  if (category === _constants.TOAST_CATEGORIES.DANGER) {
    return (0, _styledComponents.css)(["fill:", ";&:hover{fill:", ";}"], theme.colors.toast.dangerIcon, theme.colors.toast.dangerIconHover);
  }
  if (category === _constants.TOAST_CATEGORIES.SUCCESS) {
    return (0, _styledComponents.css)(["fill:", ";&:hover{fill:", ";}"], theme.colors.toast.successIcon, theme.colors.toast.successIconHover);
  }
  if (category === _constants.TOAST_CATEGORIES.NEUTRAL) {
    return (0, _styledComponents.css)(["fill:", ";&:hover{fill:", ";}"], theme.colors.toast.neutralIcon, theme.colors.toast.neutralIconHover);
  }
  if (category === 'error' || category === 'high') {
    return (0, _styledComponents.css)(["fill:", ";"], theme.colors.toast.errorIcon);
  }
});